import { format, parseISO } from "date-fns";

export function exportToCSV<T>(
  data: T[],
  fields: { label: string; key: keyof T }[],
  baseFileName: string
) {
  const timestamp = format(new Date(), "yyyyMMddHHmmss");
  const fileName = `${timestamp}_${baseFileName}.csv`;

  const headers = fields.map((f) => f.label).join(",");

  const rows = data.map((row) =>
    fields
      .map((f) => {
        const raw = row[f.key];
        let val: string = "";

        // ISO文字列で始まる場合に yyyy/MM/dd に変換
        if (typeof raw === "string" && /^\d{4}-\d{2}-\d{2}T/.test(raw)) {
          try {
            val = format(parseISO(raw), "yyyy/MM/dd");
          } catch {
            val = raw;
          }
        } else {
          val = raw !== undefined && raw !== null ? String(raw) : "";
        }

        return `"${val.replace(/"/g, '""')}"`;
      })
      .join(",")
  );

  const csvContent = `${headers}\n${rows.join("\n")}`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
